import React from 'react';
import { FieldArrayRenderProps } from 'formik';

export type HiddenFieldProps = {
  helpers: FieldArrayRenderProps;
  name: string;
  touched: boolean;
  disqualificationHandler?: (field: string, form: any) => void;
};

export default class HiddenField extends React.Component<HiddenFieldProps, {}> {
  constructor(props: HiddenFieldProps) {
    super(props);
  }

  componentDidUpdate(prevProps: HiddenFieldProps) {
    const { name, helpers, disqualificationHandler } = this.props;

    if (helpers.form.values.hiddenPostcode !== prevProps.helpers.form.values.hiddenPostcode) {
      helpers.form.setFieldValue(name, helpers.form.values.hiddenPostcode.toString(), true);
    }

    if (disqualificationHandler) {
      disqualificationHandler(name, helpers.form);
    }
  }

  render(): JSX.Element {
    const { helpers, name } = this.props;
    return <input name={name} value={helpers.form.values[name]} type={'hidden'} />;
  }
}
